<template>
  <div class="h-screen bg-white font-roboto flex">
    <div
      :class="['transition-all duration-300', isSidebarShrunk ? 'w-16' : 'w-72']"
      class="relative bg-custom-blue text-white"
    >
      <div class="flex justify-between items-center px-6 py-3">
        <div v-if="!isSidebarShrunk" class="flex items-center">
          <img src="@/assets/images/Jiji-Health-White-Logo.png" class="w-18 h-10" alt="Logo" />
        </div>
        <button @click="toggleSidebar" class="text-white">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>

      <nav>
        <div v-for="tab in sidebarTabs" :key="tab.name">
          <router-link
            :to="tab.route"
            :class="[isActive(tab) ? 'bg-custom-yellow' : 'bg-custom-blue', 'flex items-center px-4 py-3 m-2 rounded-md text-white font-semibold']"
          >
            <div v-html="tab.icon" class="w-6 h-6"></div>
            <span v-if="!isSidebarShrunk" class="ml-4">{{ tab.name }}</span>
          </router-link>
        </div>
      </nav>
    </div>

    <!-- Main Content -->
    <div class="flex-1 flex flex-col overflow-hidden">
      <Header />
      <main class="flex-1 overflow-y-auto bg-white p-6">
        <slot />
      </main>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRoute } from 'vue-router'
import sidebarTabs from '@/config/cashierSidebar'   // ← only this line differs from ConsultationLayout
import Header from '@/components/HeaderLayout.vue'

const isSidebarShrunk = ref(false)
const toggleSidebar = () => { isSidebarShrunk.value = !isSidebarShrunk.value }

const route = useRoute()
const isActive = (tab) => route.path === tab.route
</script>
